import template from './commentsButton.html';
import modal from './modal.html';

const component = {
	template,
	transclude: true,
	bindings: {
		product: '='
	},
	controller: function(
		$scope,
		$ionicModal,
		$ionicScrollDelegate,
		Product,
		$ionicActionSheet,
		$filter,
	) {
		"ngInject";

		var vm = this;
		var m;

		vm.count = this.product.comments_count;
		vm.loading = false;
		vm.comments = [];
		vm.comment = '';
		vm.keyboard = false;

		const refresh = () => {
			Product.comments(this.product.id).then(res => {
				vm.comment = '';
				vm.comments = res;
				vm.count = vm.comments.length;
				$ionicScrollDelegate.$getByHandle('comments').scrollBottom();
			});
		}

		this.show = () => {
			vm.loading = true;
			Product.comments(this.product.id).then(res => {
				if (!m) {
					m = $ionicModal.fromTemplate(modal, {
						scope: $scope,
						animation: 'slide-in-up'
					});
				}
				vm.comments = res;
				m.show();
				$ionicScrollDelegate.$getByHandle('comments').scrollBottom();
			}).finally(() => {
				vm.loading = false;
			});
		};		

		this.add = () => {
			Product.comment(this.product.id, vm.comment).then(res => {
				refresh();
			}).catch(err => {
				console.log(err);
			})
		};

		this.delete = (id) => {
			$ionicActionSheet.show({
				destructiveText: $filter('ucfirst')($filter('translate')('delete')),
				cancelText: $filter('ucfirst')($filter('translate')('cancel')),
				destructiveButtonClicked: () => {
					Product.deleteComment(id)
					.then(res => {
						refresh();
					}).catch(err => {
						console.log(err);
					})
					// close the sheet
					return true;
				}
			});
		}

		window.addEventListener('native.keyboardhide', function(){
			vm.keyboard = false;
			$scope.$apply();
		});

		window.addEventListener('native.keyboardshow', function(){
			vm.keyboard = true;
			$scope.$apply();
		});
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/commentsButton/commentsButton.component.js